<template lang="pug">
div.flex
    v-select(
      :label="field"
      :id="field"
      v-model="selected"
      @change="selectionChanged"
      :items="options"
      min-width="100%" 
      outlined
      dense
    )

</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["facet", "field"],
  data() {
    return {
      selected: null,
    };
  },
  methods: {
    selectionChanged() {
      const payload = {
        facet: this.field,
        selected: this.selected,
      };
      this.$store.dispatch("search/setFilter", payload);
    },
  },
  watch: {
    filters() {
      if (!this.filters[this.field]) {
        this.selected = [];
      }
    },
  },
  computed: {
    options() {
      if (!this.facets) return [];
      return [
        { text: "All", value: null },
        ...this.facets[this.field]
          .filter((item) => item.value !== "")
          .map((item) => ({
            text: `${item.value} (${item.count})`,
            value: item.value,
            count: item.count,
          }))
          .sort((a, b) => a.value - b.value),
      ];
    },
    ...mapState("search", ["filters", "facets"]),
  },
};
</script>
<style>
.form-group {
  margin-top: 20px;
}
.list-group-item {
  border: none;
}
</style>
